var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOdinIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 67,
    height: 89,
    viewBox: "0 0 67 89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "43.923%",
    x2: "78.855%",
    y1: "59.791%",
    y2: "62.034%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "56%",
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#A1A1A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "2.783%",
    x2: "109.278%",
    y1: "53.432%",
    y2: "63.534%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "56%",
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#A1A1A1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EED9C3",
    d: "M13.242 52.512l6.701-23.295h26.804l6.7 23.295z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.94,
    cy: 41.032,
    fill: "#353535",
    rx: 1.894,
    ry: 1.875
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A78347",
    d: "M29.408 38.9c0-.655-.536-1.185-1.197-1.185h-5.647c-.66 0-1.197.53-1.197 1.185v3.67c0 .983.804 1.779 1.795 1.779h2.056a4.213 4.213 0 0 0 2.963-1.216 4.127 4.127 0 0 0 1.227-2.933v-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DCA140",
    d: "M59.805 25.976l-6.7 6.634v-6.634l8.376-6.634z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E1AA4F",
    d: "M61.48 19.681l-8.376 6.634v-6.634l10.052-6.634z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3B261",
    d: "M53.204 6.953L66.506.118l-3.35 13.269-9.952 6.834z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DCA140",
    d: "M6.884 25.976l6.701 6.634v-6.634L5.21 19.342z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E1AA4F",
    d: "M5.209 19.681l8.376 6.634v-6.634L3.534 13.047z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3B261",
    d: "M13.351 6.732L.183.118l3.35 13.269L13.352 20z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3B261",
    d: "M53.448 19.342s-10.052-6.634-20.103-6.634c-10.052 0-20.103 6.634-20.103 6.634v19.902l2.68 5.307c2.22-8.468 9.724-11.067 16.776-5.79l.647.483.646-.483c7.045-5.271 14.566-2.64 16.776 5.79l2.68-5.307V19.342z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M19.097 10.176l-5.361 31.18-7.392-5.307 6.052-22.556z",
    transform: "translate(7.547 39.02)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M45.25 10.176l-5.36 31.18-7.392-5.307 6.052-22.556z",
    transform: "matrix(-1 0 0 1 85.297 39.02)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M5.695.225L.335 20.127l6.7 13.268 5.36-19.902z",
    transform: "translate(7.547 39.02)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M44.56.225L39.2 20.127l6.7 13.268 5.36-19.902z",
    transform: "matrix(-1 0 0 1 98.008 39.02)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M26.644 49.195l-6.03 32.507 12.73 6.634 12.733-6.634-6.031-32.507-6.201-3.07-.5-.247z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#353535",
    d: "M35.746 50.522h-4.69v1.66c0 .616.247 1.205.687 1.64.44.436 1.035.68 1.657.68h.002c.622 0 1.218-.244 1.658-.68.44-.435.686-1.024.686-1.64v-1.66z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOdinIcon);
export default __webpack_public_path__ + "static/media/odinIcon.991d749280cf85d3701195677f5c45b3.svg";
export { ForwardRef as ReactComponent };